import { BoxTitles } from "@boxes/BoxTitles";
import { BaseCurrencyInput, Button, Drawer, Radio, Select } from "@components";
import styles from "@styles/forms-flow/filtered-audience.module.scss";
import { useEffect, useState } from "react";

export const BirthdayFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [moment, setMoment] = useState(node?.data?.moment || null);
  const [value, setValue] = useState(node?.data?.value || null);

  useEffect(() => {
    onChange && onChange({ ...node, data: { ...node.data, moment, value } });
  }, [moment, value]);

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={BoxTitles.BirthdayFilter}
    >
      <p className={styles.label}>Configurações de aniversário</p>

      <Radio
        text="Dia atual"
        family="BehavioralBirthday"
        className="mb-15"
        value="DAY"
        checked={moment}
        onChange={() => setMoment("DAY")}
      />

      <Radio
        text="Tempo até o próximo aniversário"
        family="BehavioralBirthday"
        className="mb-15"
        value="DIFF_NEXT_DATE"
        checked={moment}
        onChange={() => setMoment("DIFF_NEXT_DATE")}
      />

      {moment === "DIFF_NEXT_DATE" && (
        <BaseCurrencyInput
          className="mb-15 w-100"
          prefix={""}
          suffix={" dia(s)"}
          value={value}
          precision={0}
          onChange={(v) => setValue(v)}
        />
      )}

      <Radio
        text="Mês específico"
        family="BehavioralBirthday"
        className="mb-15"
        value="MONTH"
        checked={moment}
        onChange={() => setMoment("MONTH")}
      />

      {moment === "MONTH" && (
        <Select
          title="Selecione o mês"
          className="w-100"
          value={value}
          options={[
            { label: "Janeiro", value: 1 },
            { label: "Fevereiro", value: 2 },
            { label: "Março", value: 3 },
            { label: "Abril", value: 4 },
            { label: "Maio", value: 5 },
            { label: "Junho", value: 6 },
            { label: "Julho", value: 7 },
            { label: "Agosto", value: 8 },
            { label: "Setembro", value: 9 },
            { label: "Outubro", value: 10 },
            { label: "Novembro", value: 11 },
            { label: "Dezembro", value: 12 },
          ]}
          onChange={(e) => setValue(e.target.value)}
        />
      )}

      <div className={styles.footer}>
        <Button
          onClick={() =>
            onSave({ ...node, data: { ...node.data, moment, value } })
          }
          className="w-100"
          design="primary"
        >
          Salvar
        </Button>
      </div>
    </Drawer>
  );
};
